import React from 'react';
import '../styles/index.css'

function Footer () {
    return (
        <footer className='footer'>
            <p id='footer-text'>Copyright © 2022 Chris Hong</p>
        </footer>
    )
}
export default Footer;